import { Component, EventEmitter, Input, Output } from '@angular/core';

import type { User } from '@recruitee/account-types';
import { TranslatePipe } from '@recruitee/i18n';
import type { RequisitionFlow } from '@recruitee/requisitions-types';
import {
  BadgeComponent,
  BoxComponent,
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
} from '@recruitee/user-interface';

import { RequisitionsFlowStepsListContainerComponent } from '../../../containers/single-requisition/requisitions-flow-steps-list-container/requisitions-flow-steps-list-container.component';
import { FlowStepViewContext } from '../../../requisitions.types';

@Component({
  selector: 'rt-requisitions-approval-request-flow-preview',
  templateUrl: './approval-request-flow-preview.component.html',
  styleUrls: ['./approval-request-flow-preview.component.less'],
  standalone: true,
  imports: [
    BadgeComponent,
    BoxComponent,
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    DividerComponent,
    HeadingComponent,
    IconComponent,
    RequisitionsFlowStepsListContainerComponent,
    TranslatePipe,
  ],
})
export class ApprovalRequestFlowPreviewComponent {
  @Input() public flow: RequisitionFlow;
  @Input() public adminsMap: Record<number, User>;
  @Input() public departmentName: string | undefined;
  @Input() public isDepartmentsMode: boolean;

  @Output() public continue = new EventEmitter<void>();
  @Output() public cancel = new EventEmitter<void>();

  public readonly flowViewContext = FlowStepViewContext.Dialog;
}
